import angular from 'angular';

angular.module('commonServices').filter('cxHighlight', [
  '$sce',
  function($sce) {
    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeRegexp(str) {
      return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    return function(text, query) {
      var escaped = escapeHtml(text == null ? '' : text);
      if (!query) return $sce.trustAsHtml(escaped);
      var terms = String(query)
        .split(/\s+/)
        .filter(function(t) {
          return t.length > 0;
        })
        .map(escapeRegexp);
      if (!terms.length) return $sce.trustAsHtml(escaped);
      var re = new RegExp('(' + terms.join('|') + ')', 'gi');
      return $sce.trustAsHtml(escaped.replace(re, '<mark>$1</mark>'));
    };
  },
]);
